<div class="oiq-notification-event-list">
  @for (row of items; track row.smsMessageId) {
    <div
      class="item border-dark-50 rounded border shadow"
      [class.cursor-pointer]="canOpen && row.fundingId"
      (click)="canOpen && row.fundingId && event.next({ type: 'open', data: row })">
      <span class="material-symbols-outlined">sms</span>
      <div class="notification mx-2">
        <span [class.text-primary]="canOpen && row.fundingId">{{
          row.fromName || row.fromNumber
        }}</span>
        <div class="small text-dark normal-case">{{ preview(row.body) }}</div>
        <div class="small">{{ row.clientName }}</div>
      </div>
      <span class="datetime small d-flex flex-column">
        <strong class="text-right">{{ getFormatFromNow(row.receivedAt) }}</strong>
        @if (!canOpen) {
          <button
            class="oiq-button oiq-button--primary--link oiq-button--sm ms-auto mt-1"
            (click)="event.next({ type: 'read', data: row })">
            <span>Mark as read</span>
          </button>
        }
      </span>
      <span class="status new"></span>
    </div>
  } @empty {
    <div class="small p-2 text-center">No new SMS replies.</div>
  }
</div>
